import { Component, Vue, Watch as watch } from 'nuxt-property-decorator';
import { mapState } from 'vuex';
import AuthorizedMiddleware from '~/middleware/authorized';
import { clone } from 'lodash';

@Component({
    components: {
        ordersMenu: require("~/components/pages/personal/menu").default,
    },
    computed: mapState(['user']),
})
export default class PersonalPageComponent extends Vue {

    public user: User;

    @watch('user')
    public sendUserToLoginPage() {
        if (this.$route.path !== '/personal/favorites' && !this.user) {
            this.$router.replace('/login/');
        }
    }
}
